export enum ProfileTabs {
  general = "general",
  addresses = "addresses",
  subscriptions = "subscriptions",
}

export interface ITabPanelProps {
  open: boolean;
}
